import { render, staticRenderFns } from "./CompartirInformacion.vue?vue&type=template&id=d14fe88c&"
import script from "./CompartirInformacion.vue?vue&type=script&lang=ts&"
export * from "./CompartirInformacion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('d14fe88c', component.options)
    } else {
      api.reload('d14fe88c', component.options)
    }
    module.hot.accept("./CompartirInformacion.vue?vue&type=template&id=d14fe88c&", function () {
      api.rerender('d14fe88c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plataforma/CompartirInformacion.vue"
export default component.exports